// plugins/router.ts
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.$router.options.scrollBehavior = (to, from, savedPosition) => {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          left: savedPosition?.left || 0,
          top: savedPosition?.top || 0,
        })
      }, 1000)
    })
  }
})
